module.exports = __webpack_public_path__ + "static/zeitlicher_Ablauf-7a66badf94687f0152aa3972ed289668.png";